import moment from 'moment';
import 'moment-timezone';

const DEFAULT_TIMEZONE = 'America/Los_Angeles';
const DEFAULT_MONTH_LOOKBACK = 24;

export function resolveBillingTimeZone() {
  let timeZone = sessionStorage.getItem('timeZone');

  if (![undefined, 'undefined', null, 'null', ''].includes(timeZone)) {
    const parts = String(timeZone).split(') ');
    const sessionTimeZone = parts.length > 1 ? parts[1] : timeZone;
    if (sessionTimeZone && moment.tz.zone(sessionTimeZone)) {
      return sessionTimeZone;
    }
  }

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (browserTimeZone && moment.tz.zone(browserTimeZone)) {
    return browserTimeZone;
  }

  return DEFAULT_TIMEZONE;
}

export function getCurrentMonthKey(timezone = resolveBillingTimeZone()) {
  return moment.tz(timezone).format('YYYY-MM');
}

export function buildMonthPickerOptions({
  timezone = resolveBillingTimeZone(),
  lookbackMonths = DEFAULT_MONTH_LOOKBACK,
} = {}) {
  const now = moment.tz(timezone);
  const options = [];

  for (let i = 0; i < lookbackMonths; i += 1) {
    const cursor = now.clone().subtract(i, 'months');
    options.push({
      value: cursor.format('YYYY-MM'),
      label: cursor.format('MMM YYYY'),
    });
  }

  return options;
}

export function getMonthDateRange(monthKey, timezone = resolveBillingTimeZone()) {
  const parsed = moment.tz(monthKey, 'YYYY-MM', true, timezone);

  if (!parsed.isValid()) {
    throw new Error(`Invalid month key: ${monthKey}`);
  }

  const startDate = parsed.clone().startOf('month').format('YYYY-MM-DD');
  const monthEnd = parsed.clone().endOf('month');
  const now = moment.tz(timezone);
  const isCurrentMonth = parsed.isSame(now, 'month');
  const endMoment = isCurrentMonth ? now.clone().startOf('day') : monthEnd.clone().startOf('day');

  return {
    monthKey: parsed.format('YYYY-MM'),
    startDate,
    endDate: endMoment.format('YYYY-MM-DD'),
    isCurrentMonth,
    timezone,
  };
}

export function formatMonthRangeLabel(monthKey, timezone = resolveBillingTimeZone()) {
  const { startDate, endDate } = getMonthDateRange(monthKey, timezone);
  const start = moment.tz(startDate, timezone).format('MMM D, YYYY');
  const end = moment.tz(endDate, timezone).format('MMM D, YYYY');
  return `${start} – ${end}`;
}



// WEBPACK FOOTER //
// ./src/components/billing/billingDateUtils.js